import { FC, PropsWithChildren, useEffect } from "react"
import { createPortal } from "react-dom"
import { useModal } from "@/modals"
import { IModalWrapper } from "./types"

export const ModalWrapper: FC<PropsWithChildren<IModalWrapper>> = ({
  children,

  isCanClose = true,
  ...props
}) => {
  const { type } = props

  const { modal } = useModal(type)

  useEffect(() => {
    modal.setConfig(props)
  }, [])

  useEffect(() => {
    if (!modal || !isCanClose) return

    const h = (e: KeyboardEvent) => {
      if (e.code === "Escape") {
        modal.close()
      }
    }

    window.addEventListener("keydown", h)

    return () => {
      window.removeEventListener("keydown", h)
    }
  }, [modal, isCanClose])

  if (!modal) {
    return null
  }

  const portalTarget = document.getElementById("root") || document.body

  return createPortal(<>{children}</>, portalTarget)
}
